import type { ReactNode } from 'react'

import { Navigate } from 'react-router-dom'
import { appMode } from '~/config'
import { selectHasAnyUserRole, useSessionStore } from '~/stores/session/session'
import { routes } from './paths'
import type { AppRoleEnum } from '@ulysses-inc/harami_api_client'

type Props = {
  rolesRequired: readonly AppRoleEnum[]
  children: ReactNode
}

/**
 * ログインユーザーが指定されたいずれかの role をもっている場合のみ遷移可能なルートをラップするためのコンポーネント
 *
 * キオスク端末（kiosk）の Device は role を持たないため常に不許可になる。kiosk にはログインの
 * 概念が無いので /login ではなくホームへ戻す（/login は kiosk では / へリダイレクトされるだけ）。
 *
 * @param rolesRequired
 * @returns
 */
export function RolesRequiredRoute({ rolesRequired, children }: Props) {
  const hasAnyRole = useSessionStore(selectHasAnyUserRole(rolesRequired))
  if (!hasAnyRole) {
    const to = appMode.isKiosk
      ? routes.home.buildPath({})
      : routes.login.buildPath({})
    return <Navigate to={to} replace />
  }
  return children
}
